<template>
  <div>
    <hero></hero>
  </div>
</template>
<script>

import Hero from "./components-2021/Hero";

export default {
  name: "components",
  components: {
    Hero
  },
  data() {
    return {

    }
  }
};
</script>

